import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { AccessRequestType } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { getAccessRequestTypeSelectOptions } from "../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";

export interface IncidentLogAccessRequestTypeFieldProps {
    accessRequestType?: AccessRequestType | null;
    onChange: (accessRequestType: AccessRequestType | null) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogAccessRequestTypeField(props: IncidentLogAccessRequestTypeFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getAccessRequestTypeSelectOptions(translateString)}
            selectedItem={props.accessRequestType ? props.accessRequestType.toString() : null}
            onChange={(accessRequestType) => props.onChange(accessRequestType ? (Number(accessRequestType) as AccessRequestType) : null)}
            label={translateString("accessRequestType")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogAccessRequestTypeField;
